import React, { useState } from 'react';

import { APIdeleteUser } from '../../../api/User';

import type { User } from '../../../types/user';

interface UserDeleteModalProps {
  user: User;
  show: boolean;
  onConfirm: (response: boolean) => void;
  onDismiss: () => void;
};

const UserDeleteModal: React.FC<UserDeleteModalProps> = ({ user, show, onConfirm, onDismiss }) => {
  const [saving, setSaving] = useState(false);

  const hasContent =
    user.memories_count > 0 ||
    user.sprks_count > 0 ||
    user.timelines_count > 0 ||
    user.shares_count > 0;

  const handleDelete = async () => {
    setSaving(true);
    const response = await APIdeleteUser(user.id);
    if (response.status === 204) {
      onConfirm(true);
    } else {
      onConfirm(false);
    }
    setSaving(false);
  };

  return (
    <wa-dialog label="Delete user" id="dialog-delete-user" className="dialog-delete-user" open={show}>
      <div className="delete-user-header">
        <strong>Are you sure you want to delete this user?</strong><br />
        This action cannot be undone.
      </div>
      <div className="delete-user-content wa-stack wa-gap-2">
        {hasContent && (
          <wa-callout variant="danger" className="delete-user-warning">
            <i className="fa-regular fa-circle-exclamation" slot="icon"></i>
            <strong>This user has some content associated with their account.</strong><br />
            Deleting this user will also delete all their content.
          </wa-callout>
        )}
      </div>
      <wa-button
        slot="footer"
        size="s"
        appearance="outlined"
        onClick={() => onDismiss()}
      >
        Close
      </wa-button>
      <wa-button
        size="s"
        slot="footer"
        variant="brand"
        disabled={saving}
        onClick={handleDelete}
      >
        Delete user
      </wa-button>
    </wa-dialog>
  );
}

export default UserDeleteModal;
